import script from "./SubjectPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubjectPopup.vue?vue&type=script&setup=true&lang=ts"

import "./SubjectPopup.vue?vue&type=style&index=0&id=20afed80&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20afed80"]])

export default __exports__